<div style="position: relative; width: 100%; height: 100%; background: #000;">
  <div
    *ngIf="isLoading"
    style="position: absolute; inset: 0; display: flex; align-items: center;
           justify-content: center; color: #fff; font-family: Arial, sans-serif;
           font-size: 14px; background: #000; z-index: 10;">
    Video wird geladen...
  </div>

  <video
    #videoPlayer
    playsinline
    preload="metadata"
    style="width: 100%; height: 100%; display: block; object-fit: contain;"
    (loadedmetadata)="isLoading = false"
    (canplay)="isLoading = false"
    (error)="isLoading = false">
    <source [src]="src" [type]="mimeType">
  </video>
</div>
